import i18next, { type i18n as I18n } from 'i18next';
import common_zhTW from './locales/zh-TW/common.json' with { type: 'json' };
import categories_zhTW from './locales/zh-TW/categories.json' with { type: 'json' };
import locations_zhTW from './locales/zh-TW/locations.json' with { type: 'json' };

let initialized = false;

/**
 * Initialize i18next with bundled zh-TW resources (SPEC §7).
 * v0.1 ships zh-TW only; en / ja / ko added later via lazy loading.
 */
export async function initI18n(lng: string = 'zh-TW'): Promise<I18n> {
  if (initialized) return i18next;
  await i18next.init({
    lng,
    fallbackLng: 'zh-TW',
    defaultNS: 'common',
    ns: ['common', 'categories', 'locations'],
    resources: {
      'zh-TW': {
        common: common_zhTW,
        categories: categories_zhTW,
        locations: locations_zhTW,
      },
    },
    interpolation: { escapeValue: false },
    returnNull: false,
  });
  initialized = true;
  return i18next;
}

/**
 * Translate `key` using initialized i18next. If the key is missing, returns
 * `defaultValue` (or the raw key). User-defined values (e.g. custom locations
 * from ADR-017) flow through unchanged because the lookup misses cleanly.
 */
export function t(key: string, defaultValue?: string): string {
  if (!initialized) return defaultValue ?? key;
  const result = i18next.t(key, { defaultValue: defaultValue ?? key });
  return typeof result === 'string' ? result : (defaultValue ?? key);
}

/** Translate a free-form Location string via the `locations` namespace, falling back to the raw value (ADR-017 user-defined locations). */
export function tLocation(location: string): string {
  return t(`locations:${location}`, location);
}

/** Translate a Category enum value via the `categories` namespace. */
export function tCategory(category: string): string {
  return t(`categories:${category}`, category);
}
